import { ThemeEvents } from '@theme/events';

/**
 * GoodDay pre-sale info (snippets/mp-presale-info.liquid).
 *
 * Horizon doesn't re-render the whole product section on variant change, so this
 * element swaps its contents (buyer promise + hidden selling_plan input) with the
 * version rendered for the newly selected variant.
 */
class MpPresaleInfo extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#abortController = new AbortController();
  }

  /**
   * @param {Event & { detail: any }} event - The variant update event
   */
  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const newPresaleInfo = event.detail.data.html?.querySelector('mp-presale-info');
    this.innerHTML = newPresaleInfo ? newPresaleInfo.innerHTML : '';
  };
}

if (!customElements.get('mp-presale-info')) {
  customElements.define('mp-presale-info', MpPresaleInfo);
}
